import { useDispatch } from "react-redux";
import { bookingActions } from "../../../../../store/reducers/booking";

import { Grid } from "@mui/material";

import constants from "../../../../../utils/constants";
import { constant_names } from "../../../../../utils/constants";
import LitcoTextField from "../../../../UI/LitcoTextField";
import LitcoRadioField from "../../../../UI/LitcoRadioField";

export default function InquiryClientDetails(props) {
  const { clientDetails, onClientDetailsChange, onClientDetailsChangeCustom, onConfirmDetails, actions } = props;

  const dispatch = useDispatch();

  const additionalInfo = clientDetails.additionalInfo;
  const contactPreference = additionalInfo.contactPreference;

  const clientAdditionalInfoChangeHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    onClientDetailsChangeCustom((prevState) => ({
      ...prevState,
      additionalInfo: { ...prevState.additionalInfo, [name]: value },
    }));
  };

  const bookingRequestCallback = (data) => {
    const result = data.result;

    if (result === "success") {
      dispatch(bookingActions.updateStatus(constants.BOOKING_STATUS.COMPLETE));
    }
  };

  const meetingTypeName = constant_names.MEETING_TYPE_NAMES[clientDetails.meetingType];

  return (
    <form onSubmit={(event) => onConfirmDetails(event, bookingRequestCallback)} method="POST" id="clientDetailsForm">
      <Grid container spacing={1} direction={{ xs: "column", sm: "row" }}>
        <LitcoTextField
          sm={4}
          label="First Name(s)"
          name="firstName"
          required
          value={clientDetails.firstName}
          onChange={onClientDetailsChange}
          maxLength={32}
        />
        <LitcoTextField
          sm={4}
          label="Middle"
          name="middleName"
          value={clientDetails.middleName}
          onChange={onClientDetailsChange}
          maxLength={32}
        />
        <LitcoTextField
          sm={4}
          label="Last Name(s)"
          name="lastName"
          required
          value={clientDetails.lastName}
          onChange={onClientDetailsChange}
          maxLength={32}
        />
        {meetingTypeName === "In-Person" && (
          <LitcoRadioField
            xs={12}
            mt={1}
            label="What is your communication preference?"
            name="contactPreference"
            value={contactPreference}
            radioSize="small"
            options={[{ label: "Phone" }, { label: "Email" }, { label: "No Preference", value: "noPreference" }]}
            onChange={clientAdditionalInfoChangeHandler}
            required
          />
        )}
        <LitcoTextField
          sm={6}
          label="Phone"
          helperText="10 digits, numbers only"
          value={clientDetails.phone}
          onChange={onClientDetailsChange}
          maxLength={11}
          type="numeric"
          pattern="^1?[1-9][0-9]{9}$"
          required
        />
        <LitcoTextField
          sm={6}
          label="Email"
          helperText="email@example.com"
          value={clientDetails.email}
          onChange={onClientDetailsChange}
          maxLength={64}
          type="email"
          pattern="[a-z0-9._\-]+@[a-z]+\.[a-z]{2,3}"
          required={contactPreference === "email" || meetingTypeName === "Virtual"}
        />
        <LitcoTextField
          xs={12}
          label="Any additional information or special requests?"
          name="description"
          multiline
          rows={4}
          variant="outlined"
          value={clientDetails.additionalInfo.description}
          onChange={clientAdditionalInfoChangeHandler}
        />

        <Grid item xs={12} mt={1}>
          {actions}
        </Grid>
      </Grid>
    </form>
  );
}
